import { createFileRoute } from '@tanstack/react-router'
import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '@/shared/components/ui/empty'
import { LinkButton } from '@/shared/components/ui/link-button'

export const Route = createFileRoute('/denied')({
	component: RouteComponent,
})

function RouteComponent() {
	const { t } = useTranslation()

	return (
		<Empty className='h-screen w-screen'>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<AlertTriangleIcon />
				</EmptyMedia>
				<EmptyTitle>
					{t('access_denied', { defaultValue: 'Access denied' })}
				</EmptyTitle>
				<EmptyDescription>
					{t('access_denied_description', {
						defaultValue:
							'You do not have access to this project. Please contact your administrator or support team for more information.',
					})}
				</EmptyDescription>
				<EmptyContent>
					<LinkButton asChild>
						<a href='mailto:po-support@competera.net'>
							po-support@competera.net
						</a>
					</LinkButton>
				</EmptyContent>
			</EmptyHeader>
		</Empty>
	)
}
